import React, { Fragment } from 'react';

import isResponsive, { ResponsiveProvider } from '../lib';

import './style.css';

// eslint-disable-next-line react/prop-types
const App = ({ responsive }) => (
  <div style={styles.container}>
    {Object.keys(responsive).map((key, index) => (
      <h3 key={index} style={{ color: responsive[key] ? '#61dafb' : '#333' }}>
        {key.replace('is', '').toLowerCase()}
      </h3>
    ))}
  </div>
);

const ResponsiveApp = isResponsive(App);

const Default = () => (
  <ResponsiveProvider>
    <ResponsiveApp />
  </ResponsiveProvider>
);

const Simple = () => (
  <ResponsiveProvider simple>
    <ResponsiveApp />
  </ResponsiveProvider>
);

const Detailed = () => (
  <ResponsiveProvider detailed>
    <ResponsiveApp />
  </ResponsiveProvider>
);

const AppContainer = () => (
  <Fragment>
    <Default />
    <Simple />
    <Detailed />
  </Fragment>
);

const styles = {
  container: {
    alignItems: 'center',
    backgroundColor: '#f5fcff',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center'
  }
};

export default AppContainer;



// WEBPACK FOOTER //
// ./src/example/index.js